import { dataTelephoneSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTelephoneSolid = /*#__PURE__*/createIcon(dataTelephoneSolid)
export default IconTelephoneSolid
